<section *ngIf="showInstruction" class="rounded border surface-border surface-card shadow-sm space-y-4">
  <!-- 🧾 Header -->
  <p-panel header="Important Notes" class="mb-3">
    <ng-template pTemplate="icons">
      <app-json-viewer [model]="priceRule"></app-json-viewer>
    </ng-template>
    <ul class="text-sm text-gray-700 pl-4 list-disc space-y-1">
      <li>
        <strong>Hot Deal:</strong> Hot Deal in this price rule will only apply if the course has Hot Deal enabled.
      </li>
      <li>
        <strong>Cart Setting:</strong>
        If "Use custom cart setting" is OFF, the course’s default cart price and rules will be used.
        <br>Turn it ON only if this price rule requires a different cart price or behavior.
      </li>
      <li>
        <strong>Thailand Elite / OTA:</strong> To sell this price rule to Thailand Elite members or OTA agents, you must enter base pricing for each tier. Leave blank if not applicable.
      </li>
    </ul>

  </p-panel>
</section>
<p-card *ngIf="priceRule">
  <p-fieldset legend="Price Rule" class="mt-4">
    <!-- ⛳ Slot Link Warning/Info -->
    <div class="text-center mb-3">
      <p-message
        *ngIf="relateSlot > 0"
        severity="info"
        styleClass="w-6"
        text="Linked to {{ relateSlot }} time slot{{ relateSlot > 1 ? 's' : '' }}. Changes will update all related slots."
      ></p-message>

      <p-message
        *ngIf="relateSlot === 0"
        severity="warn"
        styleClass="w-6"
        text="This rule is not linked to any time slots yet."
      ></p-message>
    </div>
    <div class="grid">
      <div class="col-8">
        <div class="max-width-1400 p-fluid">

          <form [formGroup]="formGroup">
            <formly-form [model]="priceRule" [fields]="fields" [form]="formGroup" [options]="options">
            </formly-form>
          </form>

          <hr>
          <formly-footer (save)="confirmSave()"
                         (delete)="deleteEntity()"
                         (secondary)="close(undefined)"
                         secondaryLabel="Cancel"
                         [confirmBeforeSave]="false"
                         [allowSave]="formGroup.valid"
                         [model]="priceRule"
          >
          </formly-footer>

        </div>
      </div>
      <div class="col-4"></div>
    </div>
  </p-fieldset>
</p-card>






